// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__B9FnG"};